import { useState } from 'react';
import { Box } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { buildImageUrl } from './image-utils';

interface ImageThumbnailProps {
    path?: string;
    alt?: string;
    width?: number;
    height?: number;
}

// Miniatura de imagem do portal; sem URL ou se a imagem falhar, mostra um ícone
export function ImageThumbnail({ path, alt, width = 48, height = 36 }: ImageThumbnailProps) {
    const url = buildImageUrl(path);
    const [failedUrl, setFailedUrl] = useState<string>();
    const showImage = !!url && failedUrl !== url;

    return (
        <Box
            sx={{
                width, height, flexShrink: 0, borderRadius: 0.75, overflow: 'hidden', bgcolor: 'background.default',
                border: '1px solid', borderColor: 'divider', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
        >
            {showImage
                ? <Box component="img" src={url} alt={alt} onError={() => setFailedUrl(url)} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                : <ImageIcon color={path ? 'primary' : 'disabled'} fontSize="small" />}
        </Box>
    );
}
